import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["$css"];
import React from 'react';
import styled, { css } from 'styled-components';
import StyledContainer from '../../Styled/StyledContainer';
import LinkOrButton from '../../LinkOrButton';
import { FIGURE_ORIGIN } from '../../../constants';
import { EqualHousing } from '../../svg';
import { cssByBreakpoint, flex, hover, maxWidthContainer, focus, focusStyles } from '../../../styling';
import { BREAKPOINTS_EM, COLORS, MARGINS, TYPOGRAPHY } from '../../../themes';
var TOP_ROW_ITEMS = [/*#__PURE__*/React.createElement(LinkOrButton, {
  href: "".concat(FIGURE_ORIGIN, "/terms")
}, "Terms of Service"), /*#__PURE__*/React.createElement(LinkOrButton, {
  href: "".concat(FIGURE_ORIGIN, "/privacy")
}, "Privacy Policy"), /*#__PURE__*/React.createElement(LinkOrButton, {
  href: "".concat(FIGURE_ORIGIN, "/licenses")
}, "Licenses"), /*#__PURE__*/React.createElement(LinkOrButton, {
  href: "tel:888-819-6388"
}, "Have a question? 888-819-6388")];
var BOTTOM_ROW_ITEMS = [/*#__PURE__*/React.createElement("span", null, "\xA9 ", new Date().getFullYear().toString(), " Figure Technologies, Inc"), /*#__PURE__*/React.createElement(LinkOrButton, {
  href: "http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1717824"
}, "NMLS #1717824 - NMLSCONSUMERACCESS.ORG"), /*#__PURE__*/React.createElement(StyledContainer, {
  $css: flex('flex-start', 'center')
}, /*#__PURE__*/React.createElement(EqualHousing, {
  $css: css(["margin-right:8px;transform:translateY(-0.1rem);"])
}), /*#__PURE__*/React.createElement("span", null, "Equal Housing Opportunity"))];
var Row = /*#__PURE__*/styled(StyledContainer).withConfig({
  displayName: "SimpleFooter__Row",
  componentId: "sc-7xider-0"
})(["", ""], cssByBreakpoint([css(["&:first-of-type{margin-bottom:", "px;}> *{display:block;margin-bottom:", "px;&:last-child{margin-bottom:0;}}"], MARGINS.XL, MARGINS.SM), css(["padding:12px 0;", ";&:first-of-type{margin-bottom:0;}> *{display:unset;margin-bottom:0;&:not(:last-child){padding-right:32px;border-right:2px solid ", ";}&:not(:first-child){margin-left:32px;}}"], flex('flex-start', 'center'), COLORS.NEUTRAL_300)], [BREAKPOINTS_EM.XL]));

var SimpleFooter = function SimpleFooter(_ref) {
  var $css = _ref.$css,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledContainer, _extends({
    as: "footer",
    $css: css(["width:100%;padding:", "px 0;background:", ";", " ", ";a,span{", ";color:", ";line-height:1;}a{", ";width:fit-content;", ";text-decoration:none;}"], MARGINS.XL, COLORS.WHITE, flex(), $css, TYPOGRAPHY.S_SEMIBOLD, COLORS.NEUTRAL_500, focus(css(["", ""], focusStyles)), hover('color', COLORS.NEUTRAL_500, COLORS.PRIMARY_500))
  }, rest), /*#__PURE__*/React.createElement(StyledContainer, {
    $css: maxWidthContainer()
  }, /*#__PURE__*/React.createElement(Row, null, TOP_ROW_ITEMS.map(function (item, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, item);
  })), /*#__PURE__*/React.createElement(Row, null, BOTTOM_ROW_ITEMS.map(function (item, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, item);
  }))));
};

export default SimpleFooter;